export default __webpack_public_path__ + "src/images/packages/ngama-tented-lodge/bf65bce7ddb4baa52a7543fc016dfdb1-2.jpg";